import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { FeedbackService } from './services/feedback-service';
import { FeedbackServiceImpl } from './services/impls/feedback-service';
import { FeedbackRepositoryImpl } from './repositories/impls/feedback-repository';
import { FeedbackApi } from './apis/feedback-api';
import { FeedbackApiImpl } from './apis/impls/feedback-api';
import { FeedbackRepository } from './services/shared-repositories';

export const sharedContainer = new ContainerModule(bind => {
    bind(FeedbackService).to(FeedbackServiceImpl);
    bind(FeedbackRepository).to(FeedbackRepositoryImpl);
    bind(FeedbackApi).to(FeedbackApiImpl);
});
